// extracted by mini-css-extract-plugin
export default {"btnpwd":"_1a88b7c4a6"};